function HTMLString(str) {
  this.content = str || "";
  this.elt = function(str, elt, customContent) {
    var cClass = "", cStyle = "", cId = "";
    if (customContent) {
      cClass = customContent.cClass || "";
      cStyle = customContent.cStyle || "";
      cId = customContent.cId || "";
    }
    this.content += "<" + elt + " class=\"" + cClass + "\" style=\"" + cStyle + "\" id=\"" + cId + "\">" + str + "</" + elt + ">";
    return this;
  }
  this.line = function(str, customContent) {
    return this.elt(str, "div", customContent);
  }
  this.subtitle = function(str) {
    return this.line(str, {cClass: "sensei-subtitle"});
  }
  this.iaLine = function(str, customContent) {
    var content = customContent || {};
    content.cClass = content.cClass || "" + " ia-question";
    return this.line(str, content);
  }
  this.span = function(str, customContent) {
    return this.elt(str, "span", customContent);
  }
  this.button = function(str, customContent) {
    var content = customContent || {};
    content.cClass = content.cClass || "" + " action-btn no-shadow";
    return this.elt(str, "button", customContent);
  }
  this.br = function() {
    this.content += "<br/>";
    return this;
  }
  this.toString = function() { return this.content; }
}

export default HTMLString;
